import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoReintento } from '../_models/flujo-venta-paso-reintento';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoReintentoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosReintentos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoReintento[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoReintento[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoReintento ) );
  }

  listadoPorIdFlujoVentaPaso( idFlujoVentaPaso: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVenta/' + idFlujoVentaPaso ).pipe( map( res => res as FlujoVentaPasoReintento[] ) );
  }

  crear( regCrear: FlujoVentaPasoReintento ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoReintento ) );
  }

  actualizar( regActualizar: FlujoVentaPasoReintento ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoReintento ) );
  }
}
